
































import Vue from 'vue'
import Component from 'vue-class-component'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'

@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol
  }
})
class NetworkStatusHelperComponents4DigitalCurrencyResourceItem extends Vue {

  projectName: string = projectVariables.projectName
  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenStatistics: number = 0
}

export default NetworkStatusHelperComponents4DigitalCurrencyResourceItem

